export default "__VITE_ASSET__CZFVBdjn__"